/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consultation_DescriptionInputs */

const et_consultation_description = /** @type {(inputs: Consultation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broneeri tasuta 30-minutiline konsultatsioon. Analüüsime sinu veebilehe olukorda ja koostame tegevuskava Google TOP 3 jõudmiseks.`)
};

const en_consultation_description = /** @type {(inputs: Consultation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a free 30-minute consultation. We'll analyze your website and create an action plan for reaching Google Top 3.`)
};

/**
* | output |
* | --- |
* | "Book a free 30-minute consultation. We'll analyze your website and create an action plan for reaching Google Top 3." |
*
* @param {Consultation_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const consultation_description = /** @type {((inputs?: Consultation_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consultation_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_consultation_description(inputs)
	return en_consultation_description(inputs)
});